﻿const editor = kendo.ui.Editor as any;
editor.defaultTools['insertLineBreak'].options.shift = false;
editor.defaultTools['insertParagraph'].options.shift = true;

function saveCommentOnButton() {
    const editor = $('#iHasComments_tbComment').data('kendoEditor');

    if (editor?.value() && $('#iHasComments_btAddComment')) {
        $('#iHasComments_btAddComment').trigger('click');
    }
}

function setHeightContentEditor(selector: JQuery<HTMLElement>, editorSelector: JQuery<HTMLElement>) {
    const descriptionFrameHeight = selector.contents().height() ?? 0;
    editorSelector.find('.k-widget.k-editor').height(descriptionFrameHeight + 110);
}

function kendoEditor_onExecute({ name }: kendo.ui.EditorExecuteEvent) {
    if (name === 'viewhtml') {
        setTimeout(window.setProperIframeResize);
    }
}

window.kendoEditor_onExecute = kendoEditor_onExecute;
window.setHeightContentEditor = setHeightContentEditor;
window.saveCommentOnButton = saveCommentOnButton;